// @flow
import type { Node } from 'react';

import React from 'react';
import getFullyQualifiedFieldName from '#support/utility/form/getFullyQualifiedFieldName.js';
import { FieldPopulationToggle } from '#components/pages/Models/Model/support/form/index.js';
import { EnhancedField } from '#components/support/forms/utility/index.js';

// TODO: considering updating the EnhancedField to cover the additional functionality added here

type Props = {
  excludeLabel?: boolean,
  excludeFeedback?: boolean,
  excludeTip?: boolean,
  excludePopulationToggle?: boolean,
  excludeInputGroup?: boolean,
  field: Object,
  item?: string | null,
  render?: Function,
  visible: boolean,
  autofilled?: boolean,
};

const ModelFormField = ({
  excludeLabel = false,
  excludeFeedback = false,
  excludeTip = false,
  excludePopulationToggle = false,
  excludeInputGroup = false,
  field,
  item = null,
  render = null,
  visible,
  autofilled = false,
}: Props): Node => {
  if (!visible) {
    return null;
  }

  const showPopulationToggle = !excludePopulationToggle && field.autofiller;

  // Use EnhancedField for simple cases (no population toggle)
  if (!showPopulationToggle) {
    return (
      <EnhancedField
        excludeLabel={excludeLabel}
        excludeFeedback={excludeFeedback}
        excludeTip={excludeTip}
        excludeInputGroup={excludeInputGroup}
        field={field}
        item={item}
        render={render}
        visible={visible}
        validation={field.validation}
        autofilled={autofilled}
      />
    );
  }

  // Custom wrapper for population toggle layout
  const populationToggleWrapper = (labelElement, fieldElement, feedbackElement) => {
    const fullyQualifiedName = getFullyQualifiedFieldName(item, field.name);
    const populationToggleElement = (
      <FieldPopulationToggle fieldName={fullyQualifiedName} form={field.form} />
    );

    return (
      <>
        {labelElement}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.375rem' }}>
          <div style={{ flex: '1 1 auto', minWidth: 0 }}>
            {fieldElement}
            {feedbackElement}
          </div>
          <div style={{ flex: '0 0 auto', paddingTop: '0rem', width: '140px' }}>
            {populationToggleElement}
          </div>
        </div>
      </>
    );
  };

  return (
    <EnhancedField
      excludeLabel={excludeLabel}
      excludeFeedback={excludeFeedback}
      excludeTip={excludeTip}
      excludeInputGroup={excludeInputGroup}
      field={field}
      item={item}
      render={render}
      visible={visible}
      validation={field.validation}
      autofilled={autofilled}
      customWrapper={populationToggleWrapper}
    />
  );
};

export default ModelFormField;
